import { NavLink } from 'react-router-dom';
import styles from './Header.module.css';
import cartListImg from './../../cartList.svg';
import headerLogo from './../../img/header/headerLogo.jpg';
import garland from './../../img/header/garland.png';

export const Header = ({
    cartList,
    isAuthorized,
}) => {


let admin = isAuthorized ? 'cabinet' : 'login'

    return (
        <header className={styles.header}>

{/* NEW YEAR GARLAND */}

            {/* <div className={styles.garland}>
            <img src={garland}
                        alt="headerLogo"
                        
                    />
            </div> */}

            <NavLink
                    exact
                    to='/login'
                >
            <div className={styles.showNumbers}>
                <div>вул. Віталія Вергая 8,   з 12:00 до 20:00  (093) 481 72 17</div>
                <div>вул. Нарбутівська 171/2, з 11:00 до 20:00  (097) 494 32 28</div>
            </div>
            </NavLink>

            <div className={styles.content}>
            <div className={styles.headerLogo}>
                <NavLink
                    exact
                    to='/'
                >
                    <img src={headerLogo}
                        alt="headerLogo"
                    />
                </NavLink>
            </div>

            <div className={styles.title}>
                <h1>Суші-роли без вихідних</h1>
            </div>


            <NavLink
                    exact
                    to='/login'
                >
            <div className={styles.number}>
                <div>вул. Віталія Вергая 8,   з 12:00 до 20:00  (093) 481 72 17</div>
                <div>вул. Нарбутівська 171/2, з 11:00 до 20:00  (097) 494 32 28</div>
            </div>
            </NavLink>
            <div className={styles.cartList}>

                {(cartList.length > 0) ?
                    <div className={styles.cartListCount}>
                        <span className={styles.length}>
                            {cartList.length}
                        </span>
                    </div>
                    : null
                }
                <NavLink
                    exact
                    to='cartList'
                >
                    <img src={cartListImg}
                        className={styles.cartListImg}
                        onClick={() => { }} />
                </NavLink>
            </div>
    </div>
           
        </header>
    )
}